import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-stock-place-del-times',
  templateUrl: './stock-place-del-times.component.html',
  styleUrls: ['./stock-place-del-times.component.css']
})
export class StockPlaceDelTimesComponent implements OnInit {
    stockPlaceIdTo;

    public setting?: Setting;

    public itemsListStockPlaceDelTimes: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.stockPlaceIdTo = this.stateService.getStateParams()['stockplace_id_to'];
    }

    private async loadSetting() {
        if (!!this.stockPlaceIdTo) {
            this.setting = (await this.datatask.Post(801, { stockplace_id_to: this.stockPlaceIdTo }))[0];
        }
    }

    private async loadStockPlaceDelTimes(): Promise<void> {
        if (!!this.stockPlaceIdTo) {
            this.itemsListStockPlaceDelTimes = await this.datatask.Post(782, { stockplace_id_to: this.stockPlaceIdTo });
        }
    }

    private async init() {
        this.loadSetting();
        this.loadStockPlaceDelTimes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockplace_name_to: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('stockPlaceDelTimes', {
//        templateUrl: 'views/components/views/stockPlaceDelTimes/stockPlaceDelTimes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stockPlaceDelTimesService', function ($stateParams, stockPlaceDelTimesService) {
//            const vm = this;
//            let stockPlaceIdTo = $stateParams.stockplace_id_to;

//            vm.model = {
//                setting: {},
//                itemsListStockPlaceDelTimes: []
//            };

//            let loadSetting = function () {
//                stockPlaceDelTimesService.getStockPlaceDelTimes({ stockplace_id_to: stockPlaceIdTo }).then(function (info) {
//                    angular.copy(info[0], vm.model.setting);
//                });
//            };

//            let loadStockPlaceDelTimes = function () {
//                stockPlaceDelTimesService.listStockPlaceDelTimes({ stockplace_id_to: stockPlaceIdTo }).then(function (list) {
//                    angular.copy(list, vm.model.itemsListStockPlaceDelTimes);
//                });
//            };

//            vm.$onInit = function () {
//                loadSetting();
//                loadStockPlaceDelTimes();
//            };
//        }]
//    });
//})();
